import { Menu, PanelLeft } from 'lucide-react';
import ROR_LOGO from '../../assets/Images/twiggy-logo.jpeg';
import { useAuth } from '../../context/AuthProvider';
import { useChat } from '../../context/ChatContext';
import RoleSwitcher from './RoleSwitcher';

export default function Header({
  toggleMobileSidebar,
  toggleCollapse,
  collapsed,
}) {
  const { logout } = useAuth();
  const { setActiveChatId } = useChat();

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between pt-6 pr-6 pb-1 pl-6 bg-white lg:pl-0">
      <div className="hidden p-2 mr-3 lg:block">
        <PanelLeft
          className={`text-[#7a7c7c] cursor-pointer ${
            collapsed ? 'block' : 'hidden'
          }`}
          onClick={toggleCollapse}
        />
      </div>
      <div className="flex items-center justify-between w-full gap-3">
        {/* Mobile menu button */}
        <button className="lg:hidden" onClick={toggleMobileSidebar}>
          <Menu className="text-[#7a7c7c]" />
        </button>

        <img src={ROR_LOGO} alt="Twiggy" className="w-32" />
      </div>
      <div className="flex items-center gap-3">
        <RoleSwitcher />
        <button
          className="px-4 py-[4px] font-medium text-[#002231] border-2 border-[#CCCCCC] rounded"
          onClick={() => {
            logout();
            setActiveChatId('');
          }}
        >
          Logout
        </button>
      </div>
    </header>
  );
}
